export const wait = (milliseconds: number) => {
  let timeout: NodeJS.Timeout | undefined;
  new Promise((resolve) => {
    timeout = setTimeout(resolve, milliseconds);
  });
  return timeout;
};
